import { FaHeart, FaRegHeart } from "react-icons/fa";

export default function Divider(props) {
    return (
        <div className="divider">
           <FaHeart /> <FaRegHeart /> <FaHeart /> <FaRegHeart /> <FaHeart />
        </div>
    );
}